import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

/**
 * SellerAccessButton — contextual CTA in the Navbar
 *
 * - Not logged in   → null
 * - buyer           → "Devenir créateur" (pill plein — CTA primaire, seul élément avec un fond)
 * - seller / admin  → "Espace vendeur"  (texte seul, sans contour, comme le reste de la navbar)
 */
export default function SellerAccessButton({ user, theme = "light" }) {
  const location = useLocation();

  if (!user) return null;

  const isSeller = user.role === "seller" || user.role === "admin";
  const isActive = location.pathname.startsWith("/vendeur");
  const isHome = location.pathname === "/";
  const accentColor = isHome ? "#1D5FD1" : "#0F766E";
  const accentHover = isHome ? "#17509C" : "#0B5E57";
  const isDark = theme === "dark";
  const idleText = isDark ? "#F5F5F7" : "#1D1D1F";

  if (isSeller) {
    return (
      <Link
        to="/vendeur/dashboard"
        aria-label="Accéder à votre espace vendeur"
        className="flex items-center focus:outline-none"
        style={{
          fontFamily:     "Inter, sans-serif",
          fontSize:       "12.5px",
          fontWeight:     isActive ? 700 : 400,
          textDecoration: "none",
          color:          isActive ? accentColor : idleText,
          transition:     "color 300ms ease, opacity 150ms ease",
        }}
        onMouseEnter={(e) => { e.currentTarget.style.opacity = "0.6"; }}
        onMouseLeave={(e) => { e.currentTarget.style.opacity = "1"; }}
        data-testid="nav-seller-space-btn"
      >
        Espace vendeur
      </Link>
    );
  }

  // buyer → primary CTA — seul élément à fond plein de toute la navbar
  return (
    <Link
      to="/devenir-createur"
      aria-label="Devenir créateur sur Tangig"
      className="flex items-center gap-1.5 transition-all duration-150 focus:outline-none"
      style={{
        fontFamily:      "Inter, sans-serif",
        fontSize:        "12.5px",
        fontWeight:      500,
        textDecoration:  "none",
        borderRadius:    "99px",
        padding:         "6px 14px",
        color:           "#FFFFFF",
        backgroundColor: accentColor,
        border:          "none",
      }}
      onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = accentHover; }}
      onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = accentColor; }}
      data-testid="nav-become-seller-btn"
    >
      Devenir créateur
    </Link>
  );
}
